import { render } from "./Ticket_detail.vue?vue&type=template&id=4ab2d244&scoped=true"
import script from "./Ticket_detail.vue?vue&type=script&lang=js"
export * from "./Ticket_detail.vue?vue&type=script&lang=js"

import "./Ticket_detail.vue?vue&type=style&index=0&id=4ab2d244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab2d244"]])

export default __exports__